import $ from 'jquery';

const colicare = {
    _toggleColicareTab: function($click, animationOff) {
        var $tabDown = $click.find('.tabDown'),
            $tabUp = $click.find('.tabUp'),
            $tabs = $('.tabWrapper').find('.tabUp');

        if ($tabDown.length) {
            $tabs.addClass('tabDown');
            $tabs.removeClass('tabUp');
            $('.tabWrapper')
                .find('.content')
                .hide();

            $tabDown.addClass('tabUp');
            $tabDown.removeClass('tabDown');
        } else {
            $tabUp.addClass('tabDown');
            $tabUp.removeClass('tabUp');
        }

        if (!animationOff) {
            $click
                .parent()
                .find('.content')
                .slideToggle(900);
        } else {
            $click
                .parent()
                .find('.content')
                .show();
        }
    },

    _getHash: function(){
        return location.hash;
    },
    _handleBuyClick: function(e) {
        var link = $(e.target).attr('href');
        if (link) {
            window.location = link;
        }
    },

    _bindColicareCompareClick: function() {
        $('.compare').on('click', '#ccCompare', this._doColicareCompare);
    },

    _bindColicareClick: function() {
        $('.ccTitle').on('click', (e) => {
            this._toggleColicareTab($(e.target));
        });

        if (this._getHash()) {
            var $div = $(this._getHash());

            if ($div.length) {
                this._toggleColicareTab($div.find('.ccTitle'), true);
            }
        }
    },

    _bindBuyButtonClick: function() {
        $('.ccBtn .RedButton').on('click', this._handleBuyClick);
    },

    _bindFaqParameter: function() {
        var hash = this._getHash(),
            $faqClick,
            $tabDown;

        if (hash === '#faq') {
            $faqClick = $(hash + ' .ccTitle');
            $tabDown = $faqClick.find('.tabDown');

            $tabDown.addClass('tabUp');
            $tabDown.removeClass('tabDown');
            $(hash + ' .content').show();
            document.documentElement.scrollTo(0, 700);
        }
    },

    init: function() {
        this._bindColicareClick();
        this._bindBuyButtonClick();
        this._bindFaqParameter();
    }
};

export default colicare;

